import { gql } from 'graphql-tag'

export const updateContentRecordingEvaluation = gql`
  mutation updateContentRecordingEvaluation(
    $input: UpdateContentRecordingEvaluationInput!
  ) {
    updateContentRecordingEvaluation(input: $input) {
      id
      userId
      contentIdentifier
      contentType
      audioS3Key
      evaluationResponse
      createdAt
      updatedAt
      audioUrl
    }
  }
`
